import { createContext, useContext } from 'react';

/** Что окну известно о своём «хозяине» (менеджере окон): свёрнуто ли оно и как об этом сообщить. */
export interface WindowHost {
  minimized: boolean;
  minimize: () => void;
  /** Подпись окна для панели свёрнутых окон. */
  setLabel: (label: string) => void;
}

const WindowHostContext = createContext<WindowHost | null>(null);

export const WindowHostProvider = WindowHostContext.Provider;

/** `null`, если окно рисуется вне менеджера окон (тогда сворачивание недоступно). */
export function useWindowHost(): WindowHost | null {
  return useContext(WindowHostContext);
}
